import { Link } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const colors = {
  coral: '#E8847C',
  coralLight: '#F5AEA8',
  mint: '#7ECEC1',
  mintLight: '#b8e4dd',
  cream: '#FFF9F5',
  warmGray: '#4A4543',
};

export default function SponsorGuide() {
  return (
    <div
      className="min-h-screen bg-white overflow-x-hidden"
      style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}
    >
      <Header variant="event" />

      <main className="pt-24">
        {/* Hero */}
        <section className="relative py-16 sm:py-24 overflow-hidden" style={{ backgroundColor: colors.cream }}>
          <div className="absolute inset-0 pointer-events-none">
            <div
              className="absolute -top-24 -right-24 w-[400px] h-[400px] rounded-full opacity-40"
              style={{ background: `radial-gradient(circle, ${colors.coralLight} 0%, transparent 70%)`, filter: 'blur(80px)' }}
            />
            <div
              className="absolute top-1/3 -left-16 w-[350px] h-[350px] rounded-full opacity-40"
              style={{ background: `radial-gradient(circle, ${colors.mintLight} 0%, transparent 70%)`, filter: 'blur(90px)' }}
            />
          </div>

          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <span
              className="inline-block px-5 py-2 text-xs font-bold tracking-[0.2em] uppercase mb-6"
              style={{
                backgroundColor: `${colors.mintLight}60`,
                color: colors.mint,
                borderRadius: '100px',
              }}
            >
              共創パートナー
            </span>
            <h1
              className="text-4xl sm:text-5xl lg:text-6xl font-black leading-tight tracking-tight"
              style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif" }}
            >
              協賛企業様へ
            </h1>
          </div>
        </section>

        {/* イントロ */}
        <section className="py-12 sm:py-16">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed mb-6">
              本イベントは、企業の皆様との「共創」によって実現しております。
            </p>
            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed mb-6">
              ご協賛いただく企業様は、単なるスポンサーではなく、
              <br className="hidden sm:block" />
              女性のWell-beingを社会に実装するパートナーです。
            </p>
            <p className="text-xl font-bold" style={{ color: colors.warmGray }}>
              心より感謝申し上げます。
            </p>
            <p className="mt-12 text-gray-600">
              当日の運営および事前準備につき、以下の通りご案内申し上げます。
            </p>
          </div>
        </section>

        {/* 案内セクション */}
        <section className="py-8 sm:py-12" style={{ backgroundColor: colors.cream }}>
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-14">
            {/* ブースについて */}
            <div>
              <h2
                className="text-xl font-black mb-6 pb-2 border-b-2"
                style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif", borderColor: colors.mint }}
              >
                ■ ブースについて
              </h2>
              <div className="space-y-4 text-gray-700">
                <div>
                  <p className="font-bold mb-2">ブースサイズ</p>
                  <p>・幅1,800mm × 奥行450mm × 高さ720mm</p>
                  <p>・幕板あり／キャスター付き（装飾可）</p>
                </div>
                <p>お申込み区分に準じて設置いたします。</p>
                <ul className="list-disc list-inside space-y-1">
                  <li>ゴールド協賛：1台</li>
                  <li>ダイヤモンド協賛：2台</li>
                </ul>
                <p className="text-sm text-gray-500">※会場レイアウトの都合により変更となる場合がございます。</p>
              </div>
            </div>

            {/* ステージPR */}
            <div>
              <h2
                className="text-xl font-black mb-6 pb-2 border-b-2"
                style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif", borderColor: colors.mint }}
              >
                ■ ステージPR（対象企業様）
              </h2>
              <ul className="space-y-2 text-gray-700">
                <li>・登壇時間：5分</li>
                <li>・スライド提出期限：3月7日（土）</li>
                <li>・形式：PowerPoint（16:9推奨）</li>
                <li>・提出方法：メール添付</li>
              </ul>
            </div>

            {/* ご招待客リスト */}
            <div>
              <h2
                className="text-xl font-black mb-6 pb-2 border-b-2"
                style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif", borderColor: colors.mint }}
              >
                ■ ご招待客リストのご提出
              </h2>
              <ul className="space-y-2 text-gray-700">
                <li>・提出期限：3月7日（土）</li>
                <li>・役職を含むご芳名をメールにてご送付ください</li>
              </ul>
            </div>

            {/* 当日スケジュール */}
            <div>
              <h2
                className="text-xl font-black mb-6 pb-2 border-b-2"
                style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif", borderColor: colors.mint }}
              >
                ■ 当日スケジュール
              </h2>
              <ul className="space-y-2 text-gray-700">
                <li>・受付開始：13:00（関係者受付）</li>
                <li>・搬入開始：9:00～</li>
                <li>・展示準備完了：12:30まで</li>
                <li>・撤収：20:00まで</li>
              </ul>
              <p className="mt-4 text-sm text-gray-500">※搬入口をご利用の場合は事前にご連絡ください。</p>
            </div>

            {/* 物品協賛・展示品搬入 */}
            <div>
              <h2
                className="text-xl font-black mb-6 pb-2 border-b-2"
                style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif", borderColor: colors.mint }}
              >
                ■ 物品協賛・展示品搬入について
              </h2>
              <p className="text-gray-700 mb-4">
                原則として当日持ち込みとなります。
                <br />
                配送をご希望の場合は、前日までに指定住所へご納品ください。
              </p>
              <p className="text-gray-700">配送希望の場合は、個数と内容を事前にメールでお知らせください。</p>
            </div>

            {/* 宅配便納品先 */}
            <div>
              <h2
                className="text-xl font-black mb-6 pb-2 border-b-2"
                style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif", borderColor: colors.mint }}
              >
                ■ 宅配便納品先
              </h2>
              <div className="bg-white rounded-xl p-6 shadow-sm text-gray-700 font-medium">
                <p>〒104-0031</p>
                <p>東京都中央区京橋1-7-1 TODA BUILDING 4階</p>
                <p className="mt-2">TODA HALL &amp; CONFERENCE TOKYO 管理事務室 宛</p>
                <div className="mt-6 pt-4 border-t border-gray-200">
                  <p className="font-bold text-gray-800">備考欄：</p>
                  <p>利用日（3/14）</p>
                  <p>利用会場（HALL A）</p>
                </div>
              </div>
            </div>

            {/* 各種資料送付・お問い合わせ先 */}
            <div>
              <h2
                className="text-xl font-black mb-6 pb-2 border-b-2"
                style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif", borderColor: colors.mint }}
              >
                ■ 各種資料送付・お問い合わせ先
              </h2>
              <div className="space-y-2 text-gray-700">
                <p>日本女性財団 国際女性デー チャリティーイベント実行委員会</p>
                <p>
                  <a
                    href="mailto:shogai@iwd-japanwomen.org"
                    className="font-bold hover:underline"
                    style={{ color: colors.mint }}
                  >
                    shogai@iwd-japanwomen.org
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* クロージング */}
        <section className="py-20 sm:py-28">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2
              className="text-3xl sm:text-4xl font-black mb-8"
              style={{ color: colors.warmGray, fontFamily: "'Shippori Mincho', serif" }}
            >
              共に創る一日へ
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              本イベントが、
              <br className="sm:hidden" />
              企業様にとっても「社会的価値」と「企業価値」の両立となる場となりますよう、
              <br />
              実行委員会一同、心を込めて準備しております。
            </p>
            <p className="text-xl font-bold" style={{ color: colors.warmGray }}>
              当日の成功に向け、どのようなことでもお気軽にご相談ください。
            </p>
            <Link
              to={{ pathname: '/', hash: 'sponsorship' }}
              className="inline-flex items-center gap-2 mt-12 px-6 py-3 rounded-xl font-bold text-white transition-colors hover:opacity-90"
              style={{ backgroundColor: colors.mint }}
            >
              <i className="ri-arrow-left-line text-xl" />
              協賛プラン一覧へ
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
